import { render, staticRenderFns } from "./favplayer.vue?vue&type=template&id=769ede80&scoped=true"
import script from "./favplayer.vue?vue&type=script&lang=js"
export * from "./favplayer.vue?vue&type=script&lang=js"
import style0 from "./favplayer.vue?vue&type=style&index=0&id=769ede80&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "769ede80",
  null
  
)

export default component.exports